export default "__VITE_ASSET__9413ba3a__"